import { render, staticRenderFns } from "./CardTestigos.vue?vue&type=template&id=78b601dc&scoped=true"
import script from "./CardTestigos.vue?vue&type=script&lang=js"
export * from "./CardTestigos.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/personal-admin.css?vue&type=style&index=0&id=78b601dc&prod&scoped=true&lang=css&external"
import style1 from "./CardTestigos.vue?vue&type=style&index=1&id=78b601dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b601dc",
  null
  
)

export default component.exports